import cx from 'classnames';
import { renderInlineCssVars, useDesignTokens } from '../../../theme';
import cn from './ToolbarSeparator.css.json';
import './ToolbarSeparator.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const ToolbarSeparator = props => {
  const dt = useDesignTokens();
  const toolbarSeperatorTokens = {
    bg: dt.tokens['color-container-border-4']
  };
  const style = renderInlineCssVars(toolbarSeperatorTokens, 'toolbar-separator');
  return /*#__PURE__*/_jsx("div", {
    "data-testid": props.testId,
    style: {
      ...style,
      ...props.style
    },
    className: cx(cn.toolbarSeparator, props.className)
  });
};
//# sourceMappingURL=ToolbarSeparator.js.map